import { persistStore, persistReducer } from 'redux-persist'
import reducers from './reducers/index'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'
import reduxThunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { CLEAR_ACCOUNT_DATA } from './constants'

const persistConfig = {
  key: 'root',
  version: '0.0.9',
  storage,
  // Appointment selection is navigation state. Persisting it restores the
  // previous appointment into the next QuickPay, including its form.
  migrate: state => {
    if (!state) return Promise.resolve(undefined)
    const next = { ...state }
    delete next.appointmentsReducer
    return Promise.resolve(next)
  },
  blacklist: [
    'customFormReducer',
    'cartReducer',
    'eventreducer',
    'addcardReducer',
    'plan_reducer',
    'isLoggedReducer',
    'vodReducer',
    'waiverReducer',
    'giftCardReducer',
    'appointmentsReducer'
  ]
}

const persistedReducer = persistReducer(persistConfig, reducers)

const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(applyMiddleware(reduxThunk))
)
// Rehydration can bring back account-scoped data (saved cards, profile,
// bookings) that a partial sign-out left in storage. Without a session those
// must not survive into a guest visit.
const persistor = persistStore(store, null, () => {
  if (!localStorage.getItem('customerkey')) {
    store.dispatch({ type: CLEAR_ACCOUNT_DATA })
  }
})

export { store, persistor }
